module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_02-389f776942b86301d02231da8b49140b.png";